import styled from 'styled-components';

/**
 * Единая панель и поля фильтров для списковых страниц с DataTable.
 * При viewport ≤ theme.breakpoint.listFiltersCollapse панель оборачивают в CollapsibleListFilters (см. тот же каталог).
 * Спецификация: design-system/RULES.md §12 (фильтры), design-system/MASTER.md.
 */
export const FiltersPanel = styled.div<{ $borderless?: boolean }>`
  display: flex;
  flex-wrap: wrap;
  align-items: flex-end;
  gap: ${({ theme }) => theme.space[1]}px 10px;
  margin-bottom: ${({ theme }) => theme.space[1]}px;
  padding: ${({ theme }) => theme.space[1]}px 10px;
  background: ${({ theme }) => theme.colors.white};
  border: ${({ theme, $borderless }) =>
    $borderless ? 'none' : `1px solid ${theme.colors.divider}`};
  border-radius: ${({ theme }) => theme.borderRadius}px;

  ${({ theme }) => theme.device.mobile} {
    align-items: stretch;
  }
`;

export const FilterFieldLabel = styled.label`
  display: flex;
  align-items: center;
  gap: 6px;
  font-size: ${({ theme }) => theme.fontSizes[5]}px;
  color: ${({ theme }) => theme.colors.text.secondary};

  ${({ theme }) => theme.device.mobile} {
    width: 100%;
    flex-direction: column;
    align-items: flex-start;
    gap: ${({ theme }) => theme.space[0]}px;
  }
`;

/** По умолчанию `autoComplete="off"`, чтобы нативные подсказки браузера не перекрывали кастомный UI фильтров. */
export const FilterTextInput = styled.input.attrs(() => ({
  autoComplete: 'off',
}))<{ $maxWidthPx?: number }>`
  width: 100%;
  max-width: ${({ $maxWidthPx = 180 }) => $maxWidthPx}px;
  height: 32px;
  padding: 0 12px;
  font-size: ${({ theme }) => theme.fontSizes[5]}px;
  font-family: inherit;
  border: 1px solid ${({ theme }) => theme.colors.divider};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};

  &::placeholder {
    color: ${({ theme }) => theme.colors.text.disabled};
  }

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary.main};
  }

  ${({ theme }) => theme.device.mobile} {
    max-width: none;
  }
`;

export const FilterNativeSelect = styled.select<{
  $minWidthPx?: number;
  $maxWidthPx?: number;
}>`
  width: 100%;
  min-height: 32px;
  height: 32px;
  padding: 0 ${({ theme }) => theme.space[1]}px;
  font-size: ${({ theme }) => theme.fontSizes[5]}px;
  font-family: inherit;
  border: 1px solid ${({ theme }) => theme.colors.divider};
  border-radius: ${({ theme }) => theme.borderRadius}px;
  background: ${({ theme }) => theme.colors.background};
  color: ${({ theme }) => theme.colors.text.primary};
  ${({ $minWidthPx }) => $minWidthPx != null && `min-width: ${$minWidthPx}px;`}
  ${({ $maxWidthPx }) => $maxWidthPx != null && `max-width: ${$maxWidthPx}px;`}

  &:focus {
    outline: none;
    border-color: ${({ theme }) => theme.colors.primary.main};
  }

  ${({ theme }) => theme.device.mobile} {
    min-width: 0;
    max-width: none;
  }
`;
